var _rect, _rect2, _text, _rect3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReleaseHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    color: "#115E67",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.15,
    y: 2.75,
    width: 19.2,
    height: 16.2,
    rx: 2.4,
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.15,
    y: 8.15,
    width: 20.7,
    height: 19.1,
    rx: 2.4,
    fill: "var(--system-background-light)",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 9.35,
    y: 14.05,
    fill: "currentColor",
    fontFamily: "Segoe UI, sans-serif",
    fontSize: 5.15,
    fontWeight: 700
  }, "News")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.4,
    y: 16.05,
    width: 5.2,
    height: 4.05,
    rx: 0.7,
    stroke: "currentColor",
    strokeWidth: 1.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.15 16.75H25.2",
    stroke: "currentColor",
    strokeWidth: 1.45,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.15 18.65H25.2",
    stroke: "currentColor",
    strokeWidth: 1.45,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 22.45H25.2",
    stroke: "currentColor",
    strokeWidth: 1.45,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 24.55H20.2",
    stroke: "currentColor",
    strokeWidth: 1.45,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseHistory);
export default __webpack_public_path__ + "static/media/releaseHistory.5c74b122ccf33fdbdc808977c09aaeba.svg";
export { ForwardRef as ReactComponent };